export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export class ApiError extends Error {
  constructor(message, status) { super(message); this.status = status; }
}

export async function requireResponse(response) {
  if (response.ok) return response;
  const body = await response.json().catch(() => ({}));
  const message = typeof body.detail === 'string' ? body.detail : 'Please check your details and try again.';
  throw new ApiError(message, response.status);
}

export async function requestJson(path, options = {}) {
  const response = await requireResponse(await fetch(`${API}${path}`, { cache: 'no-store', ...options }));
  return response.status === 204 ? null : response.json();
}